import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { formatDate } from "../../utils/dateFormatter";
import { PdfPreviewContent } from "../PdfPreviewContent";
import PdfPreviewHeader from "../PdfPreviewHeader";

const styles = {
    container: {
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      color: '#000',
    },
    section: {
      marginBottom: '24px',
    },
    sectionTitle: {
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '16px',
      color: '#1E40AF',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '16px',
      marginBottom: '16px',
    },
    infoItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    label: {
      fontWeight: 'bold',
      color: '#4B5563',
    },
    value: {
      color: '#1F2937',
    },
    separator: {
      height: '1px',
      backgroundColor: '#E5E7EB',
      margin: '24px 0',
      border: 'none',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse' as const,
      marginTop: '16px',
    },
    tableHeader: {
      backgroundColor: '#F3F4F6',
      color: '#4B5563',
      fontWeight: 'bold',
      padding: '12px',
      textAlign: 'left' as const,
      border: '1px solid #E5E7EB',
    },
    tableCell: {
      padding: '12px',
      border: '1px solid #E5E7EB',
      color: '#1F2937',
    },
    signatureSection: {
      marginTop: '60px',
      width: '100%',
    },
    signatureRow: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '40px',
    },
    signatureBlock: {
      width: '45%',
      textAlign: 'center' as const,
    },
    signatureLine: {
      width: '100%',
      borderBottom: '1px solid #000',
      marginBottom: '8px',
    },
    signatureCaption: {
      fontSize: '14px',
      color: '#4B5563',
    },
    dateBlock: {
      marginTop: '40px',
      textAlign: 'right' as const,
      fontSize: '14px',
      color: '#4B5563',
    },
    qrCodeSection: {
      position: 'absolute' as const,
      top: '20px',
      right: '20px',
      textAlign: 'center' as const,
    },
    qrCodeBox: {
      width: '100px',
      height: '100px',
      border: '1px solid #E5E7EB',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#F9FAFB',
    },
    qrCodeCaption: {
      fontSize: '12px',
      color: '#6B7280',
      marginTop: '4px',
    },
  };
  
export const StudentDiploma = () => {
    const diplomaData = useSelector((state: RootState) => state.student.student);
    const currentDate = new Date().toLocaleDateString('pt-BR');
    const InfoItem = ({ label, value }: any) => (
        <div style={styles.infoItem}>
          <span style={styles.label}>{label}:</span>
          <span style={styles.value}>{value || "—"}</span>
        </div>
      );
    return (
        <PdfPreviewContent>
            <div style={styles.container}>
                <PdfPreviewHeader
                    caption="Diploma de Conclusão"
                    data={[{ label: "", content: "Diploma Acadêmico" }]}
                />
                {/* <div style={styles.qrCodeSection}>
                    <div style={styles.qrCodeBox}>QR Code</div>
                    <div style={styles.qrCodeCaption}></div>
                </div> */}
                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>Informações do Estudante</h2>
                    <div style={styles.grid}>
                        <InfoItem label="Nome Completo" value={diplomaData?.fullname} />
                        <InfoItem label="Código do Estudante" value={diplomaData?.studentUniversalCode} />
                        <InfoItem label="Curso" value={diplomaData?.course} />
                        <InfoItem label="Departamento" value={diplomaData?.departament} />
                        <InfoItem label="Ano de Conclusão" value={new Date().getFullYear()} />
                    </div>
                </div>
                <div style={styles.signatureSection}>
                    <div style={styles.dateBlock}>
                        {diplomaData?.departament}, {currentDate}
                    </div>
                    <div style={styles.signatureRow}>
                        <div style={styles.signatureBlock}>
                            <div style={styles.signatureLine}></div>
                            <div style={styles.signatureCaption}>Director Acadêmico</div>
                        </div>
                        <div style={styles.signatureBlock}>
                            <div style={styles.signatureLine}></div>
                            <div style={styles.signatureCaption}>Secretária</div>
                        </div>
                    </div>
                </div>
            </div>
        </PdfPreviewContent>
    );
};
